var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "zoom-on-hover",
      on: {
        mousemove: _vm.move,
        mouseover: _vm.move,
        mouseenter: _vm.zoom,
        mouseleave: _vm.unzoom
      }
    },
    [
      _c("img", {
        ref: "normal",
        staticClass: "normal",
        attrs: { src: _vm.imgNormal }
      }),
      _vm._v(" "),
      _c("img", {
        ref: "zoom",
        staticClass: "zoom",
        attrs: { src: _vm.imgZoom || _vm.imgNormal }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }